import af_ZA from './af_ZA.json';
import ar from './ar.json';
import az from './az.json';
import bo from './bo.json';
import da from './da.json';
import de from './de.json';
import de_DE from './de_DE.json';
import el from './el.json';
import es_419 from './es_419.json';
import es_ES from './es_ES.json';
import fa from './fa.json';
import fr from './fr.json';
import fr_CA from './fr_CA.json';
import he from './he.json';
import hi from './hi.json';
import hu from './hu.json';
import id from './id.json';
import it_IT from './it_IT.json';
import ja from './ja.json';
import ka from './ka.json';
import kk from './kk.json';
import ko from './ko.json';
import lv from './lv.json';
import nl from './nl.json';
import pl from './pl.json';
import pt_BR from './pt_BR.json';
import pt_PT from './pt_PT.json';
import ro from './ro.json';
import ru from './ru.json';
import sq from './sq.json';
import sv from './sv.json';
import sw from './sw.json';
import te from './te.json';
import th from './th.json';
import tr_TR from './tr_TR.json';
import uk from './uk.json';
import uz from './uz.json';
import vi from './vi.json';
import zh_CN from './zh_CN.json';
import zh_HK from './zh_HK.json';

export default {
  'af-za': af_ZA,
  'ar': ar,
  'az': az,
  'bo': bo,
  'da': da,
  'de': de,
  'de-de': de_DE,
  'el': el,
  'es-419': es_419,
  'es-es': es_ES,
  'fa': fa,
  'fr': fr,
  'fr-ca': fr_CA,
  'he': he,
  'hi': hi,
  'hu': hu,
  'id': id,
  'it-it': it_IT,
  'ja': ja,
  'ka': ka,
  'kk': kk,
  'ko': ko,
  'lv': lv,
  'nl': nl,
  'pl': pl,
  'pt-br': pt_BR,
  'pt-pt': pt_PT,
  'ro': ro,
  'ru': ru,
  'sq': sq,
  'sv': sv,
  'sw': sw,
  'te': te,
  'th': th,
  'tr-tr': tr_TR,
  'uk': uk,
  'uz': uz,
  'vi': vi,
  'zh-cn': zh_CN,
  'zh-hk': zh_HK,
};
